(() => {
  if (window.StoneRootsSignupAttribution) return;
  const storageKey = 'stone-roots-signup-attribution-v1';
  const keys = ['source', 'medium', 'campaign', 'content', 'term', 'id'];
  let memory = null;
  let subscribed = false;
  let requestedPrivacy = false;
  let privacyReady = Promise.resolve();
  const clean = value => typeof value === 'string' && !/@|%40|[\u0000-\u001f]/i.test(value) ? value.trim().slice(0, 120) : '';
  const allowed = () => {
    if (window.StoneRootsSiteConsent) return window.StoneRootsSiteConsent.getAnalytics() === true;
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  };
  const snapshot = () => {
    const url = new URL(location.href);
    const utm = {};
    keys.forEach(key => { const value = clean(url.searchParams.get('utm_' + key)); if (value) utm['utm_' + key] = value; });
    let referrer = '';
    try {
      const ref = new URL(document.referrer);
      const internal = ref.hostname === location.hostname || ref.hostname === 'stoneroots.club' || ref.hostname.endsWith('.stoneroots.club') || ref.hostname === 'pkivad-q8.myshopify.com';
      if (!internal && /^https?:$/.test(ref.protocol) && !ref.username && !ref.password) referrer = ref.origin.slice(0, 200);
    } catch {}
    return { utm, landingPage: clean(url.pathname) || '/', referrer };
  };
  const capture = () => {
    if (!window.StoneRootsSiteConsent && window.Shopify && !window.Shopify.customerPrivacy?.analyticsProcessingAllowed) return undefined;
    if (!allowed()) {
      memory = null;
      try { sessionStorage.removeItem(storageKey); } catch {}
      return undefined;
    }
    if (!memory) {
      try { memory = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch {}
    }
    const current = snapshot();
    const tagged = Object.keys(current.utm).length > 0;
    if (!memory?.first || !memory?.last) memory = { first: current, last: current };
    else if (tagged) {
      if (!Object.keys(memory.first.utm || {}).length) memory.first = current;
      memory.last = current;
    }
    try { sessionStorage.setItem(storageKey, JSON.stringify(memory)); } catch {}
    return JSON.parse(JSON.stringify(memory));
  };
  const initialize = () => {
    if (!window.StoneRootsSiteConsent && !requestedPrivacy && window.Shopify?.loadFeatures) {
      requestedPrivacy = true;
      privacyReady = new Promise(resolve => {
        const timeout = setTimeout(resolve, 5000);
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], error => {
          clearTimeout(timeout);
          if (!error) capture();
          resolve();
        });
      });
    }
    if (!subscribed && window.StoneRootsSiteConsent) {
      subscribed = true;
      window.StoneRootsSiteConsent.subscribe(capture);
    }
    capture();
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const attribution = capture();
    if (!attribution || !Object.keys(attribution.last.utm || {}).length) return;
    try {
      const target = new URL(link.href, location.href);
      const owned = target.hostname === 'stoneroots.club' || target.hostname.endsWith('.stoneroots.club');
      if (!owned || target.hostname === location.hostname || !/^https?:$/.test(target.protocol)) return;
      if (keys.some(key => target.searchParams.has('utm_' + key))) return;
      Object.entries(attribution.last.utm).forEach(([key, value]) => target.searchParams.set(key, value));
      link.href = target.href;
    } catch {}
  }, true);
  window.StoneRootsSignupAttribution = { capture, ready: () => privacyReady };
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('astro:page-load', initialize);
  document.addEventListener('visitorConsentCollected', capture);
  window.addEventListener('pageshow', initialize);
  initialize();
})();



(() => {
  if (window.stoneRootsEmailSignupsInitialized) return;
  window.stoneRootsEmailSignupsInitialized = true;

  const pendingKey = 'stone-roots-email-signup-pending-v1';

  const normalizeLocale = (value) => {
    const locale = String(value || '').trim().toLowerCase();
    if (locale === 'sl' || locale.startsWith('sl-')) return 'sl';
    if (locale === 'en' || locale.startsWith('en-')) return 'en';
    return '';
  };

  const browserLocale = () => {
    const languages = Array.isArray(navigator.languages) && navigator.languages.length
      ? navigator.languages
      : [navigator.language];
    return languages.find((language) => normalizeLocale(language)) || '';
  };

  const updateButtonState = (form) => {
    const input = form.querySelector('[data-email-signup-input]');
    const button = form.querySelector('[data-email-signup-submit]');
    if (!input || !button) return;
    button.disabled = input.value.trim() === '' || !input.validity.valid;
  };

  const updateAllButtonStates = () => {
    document.querySelectorAll('[data-email-signup-form]').forEach((form) => {
      updateButtonState(form);
    });
  };

  const showSuccessState = (form) => {
    const input = form.querySelector('[data-email-signup-input]');
    const button = form.querySelector('[data-email-signup-submit]');
    const content = form.querySelector('[data-email-signup-content]');
    const successMessage = form.querySelector('[data-email-signup-success]');
    const errorMessage = form.querySelector('[data-email-signup-error]');
    if (!successMessage) return;

    if (input) input.value = '';
    if (errorMessage) errorMessage.hidden = true;
    if (content) content.hidden = true;
    else {
      if (input) input.hidden = true;
      if (button) button.hidden = true;
    }
    successMessage.hidden = false;
  };

  const readPending = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const writePending = (payload) => {
    try {
      window.sessionStorage.setItem(pendingKey, JSON.stringify(payload));
    } catch (_error) {
      // Shopify still records the consent when session storage is unavailable.
    }
  };

  const clearPending = () => {
    try {
      window.sessionStorage.removeItem(pendingKey);
    } catch (_error) {
      // Nothing else to clean up.
    }
  };

  const syncSuccessfulSignup = async () => {
    const successMarker = document.querySelector('[data-email-signup-shopify-success="true"]');
    const successfulForm = successMarker?.closest('[data-email-signup-form]');
    let pending = readPending();
    if (!successfulForm && !pending?.shopifyConfirmed) return;

    if (successfulForm) {
      document.querySelectorAll('[data-email-signup-form]').forEach(showSuccessState);
      if (pending && !pending.shopifyConfirmed) {
        pending = { ...pending, shopifyConfirmed: true };
        writePending(pending);
      }
    }
    const successMessage = successfulForm?.querySelector('[data-email-signup-success]');

    if (pending?.source?.includes('dialog') || pending?.source === 'shopify_home_pager') {
      document.dispatchEvent(new CustomEvent('stone-roots:email-dialog-open-success', {
        detail: { source: pending.source }
      }));
    }

    if (!pending && successfulForm) {
      document.dispatchEvent(new CustomEvent('stone-roots:email-signup-success'));
      successMessage?.focus({ preventScroll: true });
      return;
    }

    try {
      await window.StoneRootsSignupAttribution.ready();
      const payload = { ...pending.payload };
      if (!window.StoneRootsSignupAttribution.capture()) delete payload.attribution;
      const response = await fetch(pending.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      });
      if (!response.ok) throw new Error(`Signup metadata returned ${response.status}`);

      clearPending();
      document.dispatchEvent(
        new CustomEvent('stone-roots:email-signup-success', { detail: { source: pending.source } })
      );
    } catch (error) {
      console.warn('Shopify saved the signup, but Brevo metadata sync will be retried', error);
    }

    successMessage?.focus({ preventScroll: true });
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-email-signup-input]');
    if (input) updateButtonState(input.form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-email-signup-form]');
    if (!form) return;

    const section = form.closest('[data-email-signup-endpoint]');
    const input = form.querySelector('[data-email-signup-input]');
    if (!section || !input) return;

    if (!form.checkValidity()) {
      updateButtonState(form);
      return;
    }

    const source = section.dataset.emailSignupSource;
    const pageLocale = normalizeLocale(section.dataset.emailSignupLocale) || 'en';
    writePending({
      endpoint: section.dataset.emailSignupEndpoint,
      source,
      payload: {
        browserLocale: browserLocale(),
        consent: true,
        countryCode: section.dataset.emailSignupCountry,
        email: input.value.trim(),
        locale: pageLocale,
        localeSource: 'signup_page',
        pageLocale,
        preferredLocale: pageLocale,
        source,
        attribution: window.StoneRootsSignupAttribution.capture()
      }
    });
  }, true);

  window.addEventListener('pageshow', updateAllButtonStates);
  document.addEventListener('shopify:section:load', updateAllButtonStates);
  updateAllButtonStates();
  syncSuccessfulSignup();
})();
